import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    private router: Router
  ) {
    router.events.subscribe((event: any) => {
      this.navigationInterceptor(event)
    })
  }

  public navegando: boolean;

  //Shows and hides the loading during RouterEvent changes
  navigationInterceptor(event): void {;
    if (event instanceof NavigationStart) {
      this.navegando = true;
    }
    if (event instanceof NavigationEnd) {
      this.navegando = false;
    }

    // Set loading state to false in both of the below events to hide loading in case a request fails
    if (event instanceof NavigationCancel) {
      this.navegando = false
    }
    if (event instanceof NavigationError) {
      this.navegando = false
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts